import { CONFIG_TYPES, fulfillmentProviders } from '@/utils/enums/fulfillmentProviders'
import { isAmazonMCFProvider, isManualFulfillmentProvider } from '@/utils/fulfillement-utils'
import { useGetAllFulfillmentProvidersQuery } from '@/redux/slices/fulfillmentSlice'
import { findNthOccurrence } from '@/utils/array-utils'

const useFulfillmentProvider = () => {
    const { data: providers, isFetching: isFetchingProviders } =
        useGetAllFulfillmentProvidersQuery()

    const getConnectedProvider = (type, params = { occurrence: null, marketplace: null }) => {
        if (params.occurrence) {
            return findNthOccurrence(providers, 'type', type, params.occurrence)
        }

        if (params.marketplace) {
            return providers?.find(
                (f) =>
                    f.type === type &&
                    !!f.configurations?.find(
                        (c) => c.key === CONFIG_TYPES.MARKETPLACE && c.value === params.marketplace,
                    ),
            )
        }

        return providers?.find((f) => f.type === type)
    }

    const getAccountId = (provider) =>
        provider?.configurations?.find((c) => c.key === CONFIG_TYPES.USERNAME)?.value

    const providerSupportsUsername = (provider) =>
        provider?.type !== fulfillmentProviders.shipbob.type

    const isCustom = (provider) => provider?.type === fulfillmentProviders.custom_provider.type

    const isProviderConnected = (provider) => {
        if (isAmazonMCFProvider(provider)) {
            return !!provider?.configurations?.find((c) => c.key === CONFIG_TYPES.REFRESH_TOKEN)
                ?.value
        }

        if (isManualFulfillmentProvider(provider)) {
            return !!provider?.id
        }

        return (
            !!provider?.configurations?.find((c) => c.key === CONFIG_TYPES.SECRET)?.value ||
            isCustom(provider)
        )
    }

    // We check to see if the specific type of provider is connected
    const isProviderTypeConnected = (type, params = { occurrence: null, marketplace: null }) =>
        isProviderConnected(getConnectedProvider(type, params))

    return {
        allProviders: providers,
        connectedProviders: providers?.filter((provider) => isProviderConnected(provider)),
        isFetching: isFetchingProviders,
        isFetchingProviders,
        isCustom,
        getConnectedProvider,
        getAccountId,
        providerSupportsUsername,
        isProviderConnected,
        isProviderTypeConnected,
    }
}

export default useFulfillmentProvider
